<template>
  <section class="section">
    <h2 class="sub-title">Event Info</h2>
    <ul class="requirements-list">
      <li class="requirements-list__item">
        <dl class="requirements-list__item--dl">
          <dt class="item-team">
            {{ Ranking.date[lang] }}
          </dt>
          <dd
            class="detail-description"
            v-html="dataEventRanking.text.event_date"
          >
          </dd>
        </dl>
      </li>
      <li class="requirements-list__item">
        <dl class="requirements-list__item--dl">
          <dt class="item-team">
            {{ Ranking.participant[lang] }}
          </dt>
          <dd class="detail-description">
            {{ dataEventSummary.summary.runner_count.toLocaleString() }}
            {{ Ranking.man[lang] }}
          </dd>
        </dl>
      </li>
      <li
        class="requirements-list__item"
        v-if="dataEventRanking.text.distance_flag"
      >
        <dl class="requirements-list__item--dl">
          <dt class="item-team">{{ Ranking.distance[lang] }}</dt>
          <dd class="detail-description">
            {{ dataEventSummary.summary.total_distance / 1000 }} km /
            {{
              Math.round(
                (dataEventSummary.summary.total_distance / 1609.344) * 1000
              ) / 1000
            }}
            mile
          </dd>
        </dl>
      </li>
      <li
        class="requirements-list__item"
        v-if="dataEventRanking.text.country_flag"
      >
        <dl class="requirements-list__item--dl">
          <dt class="item-team">{{ Ranking.country[lang] }}</dt>
          <dd class="detail-description">
            {{ dataEventSummary.summary.area_count }}
            {{ Ranking.countries[lang] }}
          </dd>
        </dl>
      </li>
    </ul>
  </section>
</template>

<script>
import Ranking from "../../../assets/constants/ranking/ranking.json";

export default {
  props: {
    dataEventRanking: Object,
    dataEventSummary: Object,
  },
  computed: {
    Ranking: function () {
      return Ranking;
    },
    lang: function () {
      return this.$store.state.lang;
    },
  },
  name: "EventInfo",
};
</script>

<style scoped>
.requirements-list {
  margin: 15px 0 0 0;
  border-top: solid 1px var(--grayColor2);
  border-left: solid 1px var(--grayColor2);
  border-right: solid 1px var(--grayColor2);
  &__item {
    &--dl {
      .item-team {
        padding: 20px 20px 19px 20px;
        border-bottom: solid 1px var(--grayColor2);
        line-height: 1;
        font-size: 20px;
        font-weight: bold;
        background-color: var(--defaultGrayColor);
      }

      .detail-description {
        padding: 22px 20px 21px 20px;
        border-bottom: solid 1px var(--grayColor2);
        line-height: 1;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/ranking/EventInfo.vue